import {Vue} from 'vue-property-decorator';
import bus from '@/main';
import AuthService from '@/services/AuthService';
import {User} from "@/core/services/MedicaPro/models/User";
import {Subscription} from "@/helpers/Subscription";

export default class BaseComponent extends Vue {

    public isReady = false;

    constructor() {
        super();
        this.subscribeForCurrentUser();
    }

    // <editor-fold desc="Current user">

    public currentUser?: User;
    private subscribeForCurrentUser() {
        this.currentUser = AuthService.currentAuthUser;
        bus.$on(`MeRefreshed`, (user: User) => {
            this.currentUser = user;
        });
    }

    public get locale(): string {
        return 'da-dk';
    }

    // </editor-fold>

    private subscriptions: Subscription[] = [];

    public subscribe(subscription: Subscription) {
        this.subscriptions.push(subscription);
    }

    public beforeDestroy() {

    }

    public unsubscribeAll() {
        try {
            this.subscriptions.forEach(subscription => subscription.unsubscribe());
            this.subscriptions = [];
        } catch(e) {
            // Noop
        }
    }

    // <editor-fold desc="Styling">

    public get theme() {
        return this.$vuetify.theme.dark ? 'dark' : 'light';
    }

    // </editor-fold>


}
